// A titled content card for grouping page sections. Uses themed Card styling.

import React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const SectionCard = ({ title, action, children, sx, contentSx, disablePadding }) => (
  <Card sx={sx}>
    {(title || action) && (
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2.5,
            py: 2,
            gap: 1,
          }}
        >
          {title && (
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
          )}
          {action && <Box sx={{ display: "flex", gap: 1 }}>{action}</Box>}
        </Box>
        <Divider />
      </>
    )}
    <Box sx={{ p: disablePadding ? 0 : 2.5, ...contentSx }}>{children}</Box>
  </Card>
);

export default SectionCard;
